export default __webpack_public_path__ + "static/media/slider02.439bcd1d.png";